import { DateTimeService } from "../../services/date-time-service"

type CreateWeekHeaderTemplateArgs = {
  dateTimeService: DateTimeService
  weekLabel: string
}

export const createWeekHeaderTemplate = ({ dateTimeService, weekLabel }: CreateWeekHeaderTemplateArgs) => {
  return function weekHeaderTemplate(start: Date, end: Date) {
    const weekNumber = DateTimeService.getWeekNumber(start)

    const startStr = dateTimeService.format(start, "dd MMM yyyy")
    const endStr = dateTimeService.format(end, "dd MMM yyyy")

    return `${weekLabel} ${weekNumber}: ${startStr} - ${endStr}`
  }
}
